module.exports = __webpack_public_path__ + "static/36invgde-4c8e85aee019b6a024c240b294b6f1a5.gif";